import SeriesColor from "./SeriesColor";

const SeriesColorPalette: SeriesColor[] = [
  { hexColor: "#00b5ad", semanticColor: "teal" },
  { hexColor: "#a333c8", semanticColor: "purple" },
  { hexColor: "#21ba45", semanticColor: "green" },
  { hexColor: "#767676", semanticColor: "grey" },
  { hexColor: "#6435c9", semanticColor: "violet" },
];

export default SeriesColorPalette;
